import { render, staticRenderFns } from "./component.vue?vue&type=template&id=72dc8366&"
import script from "./component.vue?vue&type=script&lang=js&"
export * from "./component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\progect\\guowai\\ex_express_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72dc8366')) {
      api.createRecord('72dc8366', component.options)
    } else {
      api.reload('72dc8366', component.options)
    }
    module.hot.accept("./component.vue?vue&type=template&id=72dc8366&", function () {
      api.rerender('72dc8366', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/d2-icon/component.vue"
export default component.exports